module.exports = __webpack_public_path__ + "static/img/掌上能力_0.a65cacc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/掌上能力_0.jpg
// module id = uo+h
// module chunks = 1